<template>
  <div class="back">
    <span class="title">个人中心</span>
    <Button
      class="btn"
      @click="$router.push(`/cloud`)">
      <Icon type="ios-arrow-back" />
      <span>返回</span>
    </Button>
  </div>
</template>

<script>
export default {
  name: 'Back',
};
</script>

<style lang="scss" scoped>
.back {
  height: 50px;
  background: rgba(255, 255, 255, 1);
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title {
    font-size: 14px;
    color: rgba(0,0,0,0.85);
  }
  .btn {
    font-size: 12px !important;
    span {
      vertical-align: middle;
      i {
        font-size: 14px;
        vertical-align: middle;
        margin-right: 4px;
      }
    }
  }
}
</style>
